import { useState } from 'react';
import { useEditorContext } from '../contexts/editor';
import { SelectionChangeListenerEvent } from '../types';
import { useEditorEventHandler } from './useEditorEventHandler';

export const useSelectedNode = () => {
  const { editor } = useEditorContext();
  const [selection, setSelection] = useState<Element | null>(editor?.selection?.getNode() ?? null);
  useEditorEventHandler(Object.values(SelectionChangeListenerEvent), () => {
    setSelection(editor?.selection.getNode() ?? null);
  });
  return selection;
};
